var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.itpItems,"item-text":"ITP_NAME","item-value":_vm.valueField,"label":_vm.label,"no-data-text":'Нет доступных вариантов',"hide-details":""},on:{"input":_vm.sendInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }